import { render, staticRenderFns } from "./fengkongDefault.vue?vue&type=template&id=6755b212&scoped=true"
import script from "./fengkongDefault.vue?vue&type=script&lang=js"
export * from "./fengkongDefault.vue?vue&type=script&lang=js"
import style0 from "./fengkongDefault.vue?vue&type=style&index=0&id=6755b212&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755b212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6755b212')) {
      api.createRecord('6755b212', component.options)
    } else {
      api.reload('6755b212', component.options)
    }
    module.hot.accept("./fengkongDefault.vue?vue&type=template&id=6755b212&scoped=true", function () {
      api.rerender('6755b212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/fengkongDefault.vue"
export default component.exports